export default __webpack_public_path__ + "static/media/israel-bidur.eda651b8.svg";